import { Map, Set } from 'immutable';
import { validateField } from './newsletterFormBlockValidation';
export const genderValues = [
    'V',
    'M'
];
export const genderLabels = {
    V: 'Vrouw',
    M: 'Man'
};
export const newslettersId = [
    16,
    18,
    19,
    20
];
export const newsletterName = {
    16: 'Algemene nieuwsbrief Bibliotheek Hengelo',
    18: 'Algemene nieuwsbrief Bibliotheek Hof van Twente',
    19: 'Algemene nieuwsbrief Bibliotheek Oldenzaal',
    20: 'Nieuwsbrief de Bibliotheek op school'
};
export const newsletterLabel = {
    16: 'Ja, ik wil de nieuwsbrief van Bibliotheek Hengelo met leestips, praktische informatie, online diensten en activiteiten ontvangen.',
    18: 'Ja, ik wil de nieuwsbrief van Bibliotheek Hof van Twente met leestips, praktische informatie, online diensten en activiteiten ontvangen.',
    19: 'Ja, ik wil de nieuwsbrief van Bibliotheek Oldenzaal met leestips, praktische informatie, online diensten en activiteiten ontvangen.',
    20: 'Ja, ik ontvang de nieuwsbrief over de Bibliotheek op school met praktische tips en informatie voor docenten en geïnteresseerden.'
};
export const initialFormState = {
    emailAddress: '',
    firstName: '',
    lastName: '',
    birthDate: undefined,
    newsletters: Set()
};
export const initialBirthDate = new Date();
initialBirthDate.setFullYear(initialBirthDate.getFullYear() - 30);
export const allFields = Object.keys(initialFormState);
export const initialState = {
    data: initialFormState,
    visited: Set(),
    validationMessages: Map(),
    status: 'initial'
};
export const setFieldOnState = (setState)=>(field)=>(value)=>setState((s)=>({
                    ...s,
                    data: {
                        ...s.data,
                        [field]: value
                    }
                }));
export const toggleNewsletterOnState = (setState)=>(value)=>setState((s)=>({
                ...s,
                data: {
                    ...s.data,
                    newsletters: s.data.newsletters.has(value) ? s.data.newsletters.remove(value) : s.data.newsletters.add(value)
                }
            }));
export const setVisited = (setState)=>(field)=>setState((s)=>({
                ...s,
                visited: s.visited.add(field)
            }));
export const validateFormData = (setState)=>(all)=>setState((prevState)=>{
            const fields = all ? allFields : prevState.visited.toArray();
            const validationMessages = validateFields(fields, prevState.data);
            // When "all fields" is triggered once, ensure all is validated on updates
            const visited = Set(fields);
            return {
                ...prevState,
                validationMessages,
                visited
            };
        });
export const validateFields = (fields, data)=>fields.reduce((messages, field)=>{
        const result = validateField(field)(data[field]);
        return result.status == 'invalid' ? messages.set(field, result.message) : messages;
    }, Map());
